/* tslint:disable */
/* eslint-disable */
/**
 * BlackFriday API
 * The API Documentation for BlackFriday
 *
 * The version of the OpenAPI document: 0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from "../runtime";
/**
 *
 * @export
 * @interface SubscriberDTO
 */
export interface SubscriberDTO {
  /**
   *
   * @type {string}
   * @memberof SubscriberDTO
   */
  email: string;
  /**
   *
   * @type {string}
   * @memberof SubscriberDTO
   */
  subscribeURL: string;
}

/**
 * Check if a given object implements the SubscriberDTO interface.
 */
export function instanceOfSubscriberDTO(value: object): boolean {
  let isInstance = true;
  isInstance = isInstance && "email" in value;
  isInstance = isInstance && "subscribeURL" in value;

  return isInstance;
}

export function SubscriberDTOFromJSON(json: any): SubscriberDTO {
  return SubscriberDTOFromJSONTyped(json, false);
}

export function SubscriberDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): SubscriberDTO {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    email: json["email"],
    subscribeURL: json["subscribeURL"]
  };
}

export function SubscriberDTOToJSON(value?: SubscriberDTO | null): any {
  if (value === undefined) {
    return undefined;
  }
  if (value === null) {
    return null;
  }
  return {
    email: value.email,
    subscribeURL: value.subscribeURL
  };
}
